import React, { useEffect, useState } from 'react'
import { Badge, Container, Row, Col, Table, Card } from "react-bootstrap";
import { Button, Menu, MenuItem } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import i18next, { t } from "i18next";
import Toast from '../common/toast';
import LanguagesOptions from '../common/languageOptions';

const OrderStatusTrack = () => {
    const [params, setParams] = useSearchParams();
    const [anchorEl, setAnchorEl] = useState(null);
    const [loadingTree, setLoadingTree] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);
    const open = Boolean(anchorEl);

    const queryClient = useQueryClient();
    const t_order = params.get("t_order");
    const orderid = params.get("orderid");
    const orderstatusParam = params.get("orderstatus");
    const [orderStatus, setOrderStatus] = useState(orderstatusParam);

    const handleLanguage = (event) => {
        const lang = event.target.value;
        localStorage.setItem("lang", lang);
        i18next.changeLanguage(lang);
        document.querySelector("html").lang = lang;
        params.set("lang", lang);
        setParams(params);
        if (lang === "ar" || lang === "fa") {
            document.body.classList.remove("latino-font");
            document.body.classList.add("arabic-font");
        } else {
            document.body.classList.add("latino-font");
            document.body.classList.remove("arabic-font");
        }
    };

    const getOrderDetails = async () => {
        setLoadingTree(true);
        try {
            const promise = await axios.get(
                `${process.env.REACT_APP_API}/order-details?order_token=${t_order}&order_id=${orderid}`
            );
            setOrderDetails(promise?.data?.data);
            setOrderStatus(promise?.data?.data?.status)
            return promise?.data?.data;
        } catch (error) {
            console.error("Error fetching order details:", error);
        } finally {
            setLoadingTree(false);
        }
    };

    useEffect(() => {
        getOrderDetails();
    }, []);

    let statusBadge = "";
    // if (orderStatus === "waiting") {
    //     statusBadge = (
    //         <Badge className="primary-bg-opacity orange-color rounded-4 p-2">
    //             {t("waiting")}
    //         </Badge>
    //     );
    // } else if (orderStatus === "ready") {
    //     statusBadge = (
    //         <Badge className="green-bg-opacity text-success rounded-4 p-2">
    //             {t("ready")}
    //         </Badge>
    //     );
    // } else if (orderStatus === "preparing") {
    //     statusBadge = (
    //         <Badge className="blue-bg-opacity blue-color rounded-4 p-2">
    //             {t("preparing")}
    //         </Badge>
    //     );
    // } else if (orderStatus === "cancelled") {
    //     statusBadge = (
    //         <Badge className="red-bg-opacity text-danger rounded-4 p-2">
    //             {t("cancelled")}
    //         </Badge>
    //     );
    // } else 

    if (orderStatus === "ready") {
        statusBadge = (
            <Badge className="green-bg-opacity text-success rounded-2 p-3">
                {t("ready")}
            </Badge>
        );
    } else if (orderStatus === "at delivery") {
        statusBadge = (
            <Badge className="blue-bg-opacity blue-color rounded-2 p-3">
                {t("at delivery")}
            </Badge>
        );
    } else if (orderStatus === "delivered") {
        statusBadge = (
            <Badge className="green-bg-opacity text-success rounded-2 p-3">
                {t("delivered")}
            </Badge>
        );
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const hanldeStatus = async (status) => {
        setOrderStatus(status)
        const { data: response } = await axios.post(
            `${process.env.REACT_APP_API}/update-order-status`,
            {
                status: status,
                order_id: orderid,
                order_token: t_order
            }
        );
        return response.data;
    };

    const { mutate, isLoading } = useMutation(hanldeStatus, {
        onSuccess: () => {
            handleClose();
            handleToast(true, t("Changes Has Been Saved Successfully"), true);
        },
        onError: () => {
            handleToast(true, t("Error While Saving The Changes"), false);
            handleClose();
        },
        onSettled: () => {
            queryClient.invalidateQueries("changeOrderStatus");
        },
    });

    const handleToast = (open, message, success) => {
        params.set("toastOpen", open);
        params.set("message", message);
        params.set("success", success);
        setParams(params);
    };

    return (
        <Container className="d-flex flex-column align-items-center justify-content-center mt-4 alignByLang">
            <LanguagesOptions handleLanguage={handleLanguage} />

            {orderDetails && (
                <Card className="p-3 mt-2 shadow-sm w-100 alignByLang">

                    <h5 className="text-center mb-4 mt-2">{t("Order details")}</h5>
                    <Row className="mb-4">
                        <Col md={6} className='alignByLang'>
                            <h6>{t("Order ID") + " "}: {orderDetails.order_id}</h6>
                            <p>{t("Customer") + " "}: {orderDetails.customer || t("Not provided")}</p>
                            <p>{t("Location") + " "}: {orderDetails.location || t("Not provided")}</p>
                            <p>{t("Time") + " "}: {orderDetails.time}</p>
                            <p>{t("Note") + " "}: {orderDetails.note || " // "}</p>
                            <p>{t("Total") + " "}: {orderDetails.total}</p>
                            <p>{t("Payment Method") + " "}: {orderDetails.payment_method || t("Not provided")}</p>
                            <p>{t("Status") + " "}: {t(orderStatus) || t("Not provided")}</p>
                        </Col>
                        <div style={{ margin: "auto" }} className="text-center">
                            {/* {t("Change Order Status")} */}
                            <Button
                                disabled={orderStatus === "delivered"}
                                variant="text"
                                className="my-2"
                                onClick={handleClick}
                                sx={{ fontSize: "1.1rem" }}
                            >
                                {statusBadge}
                            </Button>
                        </div>
                        <Col md={6} className='alignByLang'>
                            <Table striped bordered hover>
                                <thead>
                                    <tr className='text-center'>
                                        <th>{t("Name")}</th>
                                        <th>{t("Quantity")}</th>
                                        <th>{t("Price")}</th>
                                        <th>{t("Notes")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderDetails.items.map((item, index) => (
                                        <tr className='text-center' key={index}>
                                            <td>{item.name}</td>
                                            <td>{item.qty}</td>
                                            <td>{item.price}</td>
                                            <td>{item.notes || t("No notes")}</td>
                                        </tr>

                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>


                </Card>
            )}

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    style: {
                        backgroundColor:
                            localStorage.getItem("mode") === "dark" ? "#1a1a1a" : "#fff",
                    },
                    sx: {
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: "center", vertical: "top" }}
                anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            >
                {orderStatus === "at delivery" || orderStatus === "delivered" ?
                    <MenuItem onClick={() => mutate("delivered")}>
                        <Button className="green-bg-opacity text-success rounded-2 w-100 p-2">
                            {t("delivered")}
                        </Button>
                    </MenuItem> :
                    <>
                        <MenuItem onClick={() => mutate("at delivery")}>
                            <Button className="blue-bg-opacity blue-color rounded-2 w-100 p-2">
                                {t("at delivery")}
                            </Button>
                        </MenuItem>
                        <MenuItem onClick={() => mutate("delivered")}>
                            <Button className="green-bg-opacity text-success rounded-2 w-100 p-2">
                                {t("delivered")}
                            </Button>
                        </MenuItem>
                    </>
                }

            </Menu>
            <Toast />
        </Container>
    );
};

export default OrderStatusTrack;
